import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { authToken } = useAuth();

  if (!authToken) {
    // Encode the full attempted path+search so nothing is lost.
    // LoginPage already reads qParams.get("next") — no changes needed there.
    return <Navigate to={`/login`} replace />;
  }

  // Layout-route: no children prop → render nested routes via <Outlet>
  return children ?? <Outlet />;
}
